import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostLabRequirement from '.';

interface IPostLabRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostLabRequirement = ({onSuccess}: IPostLabRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ILabRequirementPayload) => {
      return PostLabRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostLabRequirement};
